import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'colorstatustext'
})

export class ColorStatusTextPipe implements PipeTransform {

    constructor(
        private translateService: TranslateService
    ) {

    }

    transform(value: any): string {
        let status: string;
        if (value != null) {
            switch (value) {
                case "private":
                    status = 'grey';
                    break;

                case "public":
                    status = 'green';
                    break;

                case "archived":
                    status = 'red';
                    break;

                case "delete":
                    status = 'purple';
                    break;

                case "wait":
                    status = '#ffbd46';
                    break;
            }
        }
        return status;
    }
}